import { getTenantProducts, getCommonProducts, TenantProductQueryParams, CommonProductQueryParams } from '../../shared/tenant';

export const tenantQueries = {
  queries: {
    tenantProducts: (params?: TenantProductQueryParams) => ({
      queryKey: ['shared', 'tenant-products', ...(params ? [params] : [])],
      queryFn: async () => {
        return getTenantProducts(params);
      }
    }),
    commonProducts: (params?: CommonProductQueryParams) => ({
      queryKey: ['shared', 'common-products', ...(params ? [params] : [])],
      queryFn: async () => {
        return getCommonProducts(params);
      }
    })
  }
};